import { request } from './index'
import { HTTP_METHODS } from './const'
import StateStorage from '../state-storage'

class Voucher {
  static async getVoucher(noCacheflagValue, productId = null) {
    const lang = StateStorage.getLanguage()
    const shop = StateStorage.getShop()
    const keyName = `pomeloVoucher`
    const localStateKey = `${keyName}-${shop}-${lang}`
    const cached = StateStorage.getLocalState(localStateKey)
    const path = productId
      ? `v6/vouchers?product_ids=${productId}`
      : 'v6/vouchers'

    if (cached !== undefined && cached !== null && !noCacheflagValue) {
      const res = Promise.resolve(cached)
      return res
    }

    const res = await request({
      url: path,
      method: HTTP_METHODS.get,
    })

    if (res.vouchers && !noCacheflagValue) {
      StateStorage.saveLocalState(localStateKey, res, 1800)
    }

    return res
  }

  static async getVouchersCombined(noCacheflagValue) {
    const lang = StateStorage.getLanguage()
    const shop = StateStorage.getShop()
    const keyName = `pomeloVouchersCombined`
    const localStateKey = `${keyName}-${shop}-${lang}`
    const cached = StateStorage.getLocalState(localStateKey)

    if (cached !== undefined && cached !== null && !noCacheflagValue) {
      const res = Promise.resolve(cached)
      return res
    }

    const res = await request({
      url: 'v6/vouchers/combined',
      method: HTTP_METHODS.get,
    })

    if (res.vouchers && !noCacheflagValue) {
      StateStorage.saveLocalState(localStateKey, res, 1800)
    }

    return res
  }

  static async getProductsVouchers(productIds = []) {
    const product_ids = productIds.join(',')

    const path = product_ids
      ? `v6/vouchers/products?product_ids=${product_ids}`
      : 'v6/vouchers/products'

    const res = await request({
      url: path,
      method: HTTP_METHODS.get,
    })

    return res
  }
}

export default Voucher
